import { queryOptions } from '@tanstack/react-query';
import { serviceFeeApi } from './service-fee-api';

export const serviceFeeKeys = { all: ['service-fee'] as const };

export const serviceFeeQueries = {
  detail: () =>
    queryOptions({ queryKey: serviceFeeKeys.all, queryFn: () => serviceFeeApi.get() }),
};
